import React from "react";
import "./style.scss";



const LoaderEmail= ({ textMain, textSub }) => {
  return (
    <div className="loader-overlay">
      <div className="custom-loader">
        <p className="loader-text loader-text--main">{textMain}</p>
        <p className="loader-text loader-text--sub">{textSub}</p>
        <div className="loader" id="loader-1">
          <div className="loader-spinner">
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoaderEmail;
